var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#e65e17",
    height: 512,
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 512,
    rx: "15%",
    width: 512
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 256,
    fill: "#fff",
    r: 150
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 256,
    r: 99
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 257,
    r: 47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 409,
    r: 47
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 104,
    r: 47
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 104,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 409,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 257,
    r: 36
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420 266v-19h-60v19zM179 385l17 10 31-53-17-9zm17-268l-17 10 31 52 17-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.83f1a3225b44d47a3912f2c25e0dc4c5.svg";
export { ForwardRef as ReactComponent };